import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/sponsor';
import { dispatch } from '@dynamika-shared/utils/saga';
import { createSliceHook, Resp } from '../helpers';
import { SponsorEligibilityFetchAction } from './sponsorEligibility.types';
import { SponsorEligibilitySlice } from './sponsorEligibility.slice';
import { SponsorOverviewItem } from '../sponsorOverview/sponsorOverview.types';
import { PaginatedResponse } from '@dynamika-shared/types/general';

export function* sponsorEligibilityFetchWorker({
  payload: { clinicalTrialId, params },
}: SponsorEligibilityFetchAction) {
  try {
    const response: Resp<typeof api.fetchSponsorStatistics> = yield call(
      api.fetchSponsorStatistics,
      clinicalTrialId,
      'ELIGIBILITY_LIST',
      params
    );
    yield dispatch(
      actions.fetchSponsorEligibilitySuccess(
        response.data as PaginatedResponse<SponsorOverviewItem>
      )
    );
  } catch (e) {
    yield dispatch(actions.fetchSponsorEligibilityError(e as Error));
  }
}

export function* sponsorEligibilitySaga() {
  yield takeLatest(
    actions.fetchSponsorEligibility.type,
    sponsorEligibilityFetchWorker
  );
}

export const actions = {
  ...SponsorEligibilitySlice.actions,
};

export const useSponsorEligibilitySlice = createSliceHook(
  SponsorEligibilitySlice.name,
  actions
);
